import styled from 'styled-components'

export const Root = styled.div`
  height: ${ (props) => (props.orientation === 'horizontal' ? '1px' : '80%') };
  width: ${ (props) => (props.orientation === 'horizontal' ? '100%' : '0') };
  padding-left: ${ (props) =>
    props.orientation === 'horizontal' ? '0px' : '1px' };
  margin: 0;
  ${ (props) => props.margin && `margin-top: ${ props.margin }px;` }
  ${ (props) => props.margin && `margin-bottom: ${ props.margin }px;` }
    border: none;
  background-color: ${ (props) => props.theme.colors.divider };
  flex-shrink: 0;
  flex-grow: 0;
`
